import * as devisConf from '@/configuration/devisConf';
import moment from 'moment';

export default function validation(response, messages, isNewDevisCommande, type, reseaux) {
  let i18nType = '';
  switch (type) {
    case devisConf.TYPE_DEVIS:
      i18nType = 'validationDevis';
      break;
    default:
      i18nType = '';
      break;
  }
  if (response === 'ECHEANCIER_ERROR') {
    messages.push({
      message: i18nType + '.echeancierError',
    });
  }
  if (!response.data || !response.data.error || !response.data.error.validationErrors || !type) {
    return;
  }

  if (isNewDevisCommande !== null) {
    if (isNewDevisCommande) {
      messages.push({
        message: i18nType + '.saveImpossible',
      });
    } else {
      messages.push({
        message: i18nType + '.editImpossible',
      });
    }
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LEAST_ONE_CUSTOMER') === 0) {
      messages.push({
        message: i18nType + '.leastOneCustomer',
      });
    }
    if (message.indexOf('NORMAL_LINE_REQUIRED_BETWEEN_2_DISCOUNT_LINE') === 0) {
      messages.push({
        message: i18nType + '.normalLine',
      });
    }
    if (message.indexOf('TIMETABLE_S_COMMAND_LINES_SHOULD_HAVE_SAME_BILLING_TYPE') === 0) {
      messages.push({
        message: i18nType + '.sameBillingType',
      });
    }
    if (message.indexOf('ETAT_DE_LA_DEMANDE_SHOULD_BE_TRUE') === 0) {
      messages.push({
        message: i18nType + '.etatDemandeShouldBeTrue',
      });
    }
    if (message.indexOf('REFUND_HIGHER_THAN_FACTURE') === 0) {
      messages.push({
        message: i18nType + '.refundGreaterThanFacture',
      });
    }
    if (message.indexOf('DISCOUNT_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.needDiscount',
      });
    }
    if (message.indexOf('LEAST_ONE_ADVERTISER') === 0) {
      messages.push({
        message: i18nType + '.leastOneAdvertiser',
      });
    }
    if (message.indexOf('TIMETABLE_S_COMMAND_LINES_SHOULD_HAVE_SAME_SUPPLIER') === 0) {
      messages.push({
        message: i18nType + '.sameSupplier',
      });
    }
    if (message.indexOf('PROSPECT_NOT_ALLOWED') === 0) {
      messages.push({
        message: i18nType + '.prospectNotAllowed',
      });
    }
    if (message.indexOf('SUPPLIER_NOT_ALLOWED_IF_COMPANY_ONLY_HAS_MANAGEMENT') === 0) {
      messages.push({
        message: i18nType + '.supplierNotAllowedIfRegie',
      });
    }
    if (message.indexOf('LEAST_ONE_PAYER') === 0) {
      messages.push({
        message: i18nType + '.leastOnePayer',
      });
    }
    if (message.indexOf('POURCENTAGE_DIVISION') === 0) {
      messages.push({
        message: i18nType + '.pourcentageDivision',
      });
    }
    if (message.indexOf('RENOUVELABLE_REQUIRED_IF_RECONDUCTIBLE') === 0) {
      messages.push({
        message: i18nType + '.renouvellableRequiredIfReconductible',
      });
    }
    if (message.indexOf('NOT_SAME_DIVISION_TYPE') === 0) {
      messages.push({
        message: i18nType + '.notSameDivisionType',
      });
    }
    if (message.indexOf('AMOUNT_DIVISION') === 0) {
      messages.push({
        message: i18nType + '.amountDivision',
      });
    }
    if (message.indexOf('PROXY_NOT_REPRESENTATIVE') === 0) {
      messages.push({
        message: i18nType + '.proxyNotRepresentative',
      });
    }
    if (message.indexOf('LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: i18nType + '.leastOneProduct',
      });
    }
    if (message.indexOf('IN_QUOTATION_LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: i18nType + '.leastOneProductInQuotation',
      });
    }
    if (message.indexOf('UNIT_PRICE_LESS_ZERO') === 0) {
      messages.push({
        message: i18nType + '.unitPriseLessZero',
      });
    }
    if (message.indexOf('QUANTITY_LESS_ZERO') === 0) {
      messages.push({
        message: i18nType + '.quantityLessZero',
      });
    }
    if (message.indexOf('DISCOUNT_BETWEEN_0_100') === 0) {
      messages.push({
        message: i18nType + '.discountBetween0100',
      });
    }
    if (message.indexOf('DISCOUNT_BETWEEN_0_AMOUNT') === 0) {
      messages.push({
        message: i18nType + '.discountBetween0Amount',
      });
    }
    if (message.indexOf('RECIPIENT_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.destinataire',
      });
    }
    if (message.indexOf('ORDER_NO_MANUAL_TEMPO_SALE') === 0) {
      messages.push({
        message: i18nType + '.noTempoSaleWithManual',
      });
    }
    if (message.indexOf('DELETE_QUOTATION_HAVE_ORDER') === 0) {
      const elements = message.split('|')[0].split('@');
      let commandes = elements[2];
      commandes = commandes.replace('_', ' ');
      messages.push({
        message: i18nType + '.quotationWithOrder',
        parametres: {
          devis: elements[1],
          commandes: commandes,
        },
      });
    }
    if (message.indexOf('INVOICE_CODE_MUST_BE_REPLACED_FULLY') === 0) {
      const elements = message.split('|')[0].split('@');
      const codeCommande = elements[1];
      messages.push({
        message: i18nType + '.invoiceCodeMustBeReplacedFully',
        parametres: {
          param1: codeCommande,
        },
      });
    }
    if (message.indexOf('NO_ORDER_LINKED_TO_BILL') === 0) {
      messages.push({
        message: i18nType + '.noOrderLinkedToBill',
      });
    }
    if (message.indexOf('REGULATION_MODE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.regulationModeRequired',
      });
    }
    if (message.indexOf('SETTLEMENT_PERIOD_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.settlementPeriodRequired',
      });
    }
    if (message.indexOf('ACCOUNTING_ACCOUNT_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.accountingAccountRequired',
      });
    }
    if (message.indexOf('PAYMENT_PLAN_DIFFERENT') === 0) {
      messages.push({
        message: i18nType + '.paymentDifferent',
      });
    }
    if (message.indexOf('ACOMPTE_AMOUNT_TOO_GREAT') === 0) {
      messages.push({
        message: i18nType + '.acompteAmountTooGreat',
      });
    }
    if (message.indexOf('ACOMPTE_PAYER_INCORRECT') === 0) {
      messages.push({
        message: i18nType + '.acomptePayerIncorrect',
      });
    }
    if (message.indexOf('UPDATE_FORBIDDEN_ON_SAVED_ACOMPTE') === 0) {
      messages.push({
        message: i18nType + '.updateSavedAcompte',
      });
    }
    if (message.indexOf('FORBIDDEN_ON_AFFECTED_ACOMPTE') === 0) {
      messages.push({
        message: i18nType + '.forbiddenAffectedAcompte',
      });
    }
    if (message.indexOf('FACTURE_SAVED_STATE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.factureSavedStateRequired',
      });
    }
    if (message.indexOf('Facture_AmountLowerThanAcomptes') === 0) {
      messages.push({
        message: i18nType + '.acompteGreaterThanFacture',
      });
    }
    if (message.indexOf('ACOMPTE_MULTI_PAYER_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.acompteMultipayeurForbidden',
      });
    }
    if (message.indexOf('TAUX_TVA_SHOULD_BE_ZERO_WITH_PAYER_WITH_EXONERATION_TVA') === 0) {
      messages.push({
        message: i18nType + '.ligneCommandeWithZeroTva',
      });
    }
    if (message.indexOf('PAYER_MUST_HAVE_SAME_EXONERATION_TVA') === 0) {
      messages.push({
        message: i18nType + '.payerWithSameExonerationTva',
      });
    }
    if (message.indexOf('CUMULATIV_DOWN_PAYMENT_AMOUNT_GREATER_THAN_AMOUNT@') === 0) {
      const commandeId = message.split('|')[0].split('@')[1];
      messages.push({
        message: i18nType + '.sumMontantAcompteGreatForOrder',
        parametres: {
          commandeId: commandeId,
        },
      });
    } else if (message.indexOf('CUMULATIV_DOWN_PAYMENT_AMOUNT_GREATER_THAN_AMOUNT') === 0) {
      messages.push({
        message: i18nType + '.sumMontantAcompteGreat',
      });
    }
    if (message.indexOf('FORBIDDEN_ON_SAME_PRODUCT_SAME_DATES') === 0) {
      messages.push({
        message: i18nType + '.sameProduct',
      });
    }
    if (message.indexOf('QTE_SOUHAITEE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.qteFacesSouhaiteesInf',
      });
    }
    if (message.indexOf('ANNEE_SEMAINE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.anneeSemaineRequired',
      });
    }
    if (message.indexOf('DATE_RENOUVELLEMENT_REQUIRED_IF_RENEWABLE') === 0) {
      messages.push({
        message: i18nType + '.dateRenouvellementObligatoire',
      });
    }
    if (message.indexOf('DATE_PREAVIS_REQUIRED_IF_RENEWABLE') === 0) {
      messages.push({
        message: i18nType + '.datePreavisObligatoire',
      });
    }
    if (message.indexOf('DATE_RENOUVELLEMENT_FORBIDDEN_WITHOUT_RENOUVELABLE') === 0) {
      messages.push({
        message: i18nType + '.dateRenouvellementForbiddenWithoutRenouvelable',
      });
    }
    if (message.indexOf('DATE_PREAVIS_FORBIDDEN_WITHOUT_RENOUVELABLE') === 0) {
      messages.push({
        message: i18nType + '.datePreavisForbiddenWithoutRenouvelable',
      });
    }
    if (message.indexOf('The AgenceId field is required.') === 0) {
      messages.push({
        message: i18nType + '.agenceId',
      });
    }
    if (message.indexOf('DATES_OVERLAP') === 0) {
      messages.push({
        message: i18nType + '.faceDateOverlap',
      });
    }
    if (message.indexOf('UPDATE_FORBIDDEN_IF_LOGISTIC_ASSIGNMENT_VALIDATED') === 0) {
      messages.push({
        message: i18nType + '.updateForbiddenIfLogisticAssignment',
      });
    }
    if (message.indexOf('ALL_NORMAL_LINES_SHOULD_HAVE_SAME_TVA') === 0) {
      messages.push({
        message: i18nType + '.LesLignesDansUnRegroupementPersonnaliseMemeTva',
      });
    }
    if (message.indexOf('SHOUD_NOT_BE_EMPTY') === 0) {
      messages.push({
        message: i18nType + '.ShoudContainsLocationOrBillBoard',
      });
    }
    if (message.indexOf('TOTAL_HT_LOWER_THAN_DISCOUNT_LINE') === 0) {
      messages.push({
        message: i18nType + '.TotalHtLowerThanDiscountLine',
      });
    }
    const errorStock = message.split('|')[0].split('@');
    if (errorStock[0] === 'INSUFFICIENT_STOCK_YEARWEEK') {
      messages.push({
        message: i18nType + '.insuficientStockYearweek',
        parametres: { produit: errorStock[2], week: errorStock[3].substr(4, 6) },
      });
    }
    if (errorStock[0] === 'INSUFFICIENT_STOCK_DATED') {
      messages.push({
        message: i18nType + '.insuficientStockDated',
        parametres: {
          produit: errorStock[2],
          dateDebut: errorStock[3].split(' ')[0],
          dateFin: errorStock[4].split(' ')[0],
        },
      });
    }
    if (message.indexOf('The field The field AdressePostale.Ville must be a string') !== -1) {
      messages.push({
        message: i18nType + '.villeClientObligatoire',
      });
    }
    if (message.indexOf('The field The field AdressePostale.Intitule1 must be a string') !== -1) {
      messages.push({
        message: i18nType + '.intituleClientObligatoire',
      });
    }
    if (message.indexOf('SHOULD_NOT_CONTAIN_ETAT_OBTENU_REPONSE') === 0) {
      messages.push({
        message: i18nType + '.etatObtenuReponse',
      });
    }
    if (message.indexOf('NEW_COMMAND_LINES_SHOULD_BE_AT_THE_END_IN_PARTIALLY_ORDERED_QUOTATION') === 0) {
      messages.push({
        message: i18nType + '.newCommandeLigneAtEnd',
      });
    }
    if (message.indexOf('ONLY_ONE_PAYER_MANAGEMENT_QUOTATION_ORDER') === 0) {
      messages.push({
        message: i18nType + '.onlyOnePayeur',
      });
    }
    if (message.indexOf('NO_CUSTOM_BUNDLE_LINE_MANAGEMENT_QUOTATION_ORDER') === 0) {
      messages.push({
        message: i18nType + '.noRegroupementPerso',
      });
    }
    if (message.indexOf('NEW_COMMANDE_LINE_NOT_ALLOWED_IN_BILL_MULTI_ORDER') === 0) {
      messages.push({
        message: i18nType + '.newCommandeLigneNotAllowedInBillMultiOrder',
      });
    }
    if (message.indexOf('NEW_INTERVENANT_NOT_ALLOWED_IN_BILL_MULTI_ORDER') === 0) {
      messages.push({
        message: i18nType + '.newIntervenantNotAllowedInBillMultiOrder',
      });
    }
    if (message.indexOf('ECHEANCIER_MANUEL_SHOULD_HAVE_ECHEANCIER_LIGNE') === 0) {
      messages.push({
        message: i18nType + '.echeancierManuelShouldHaveEcheancierLignes',
      });
    }
    if (message.indexOf('NORMAL_BILL_AMOUNT_POSITIVE') === 0) {
      messages.push({
        message: i18nType + '.normalBillAmountPositive',
      });
    }
    if (message.indexOf('AVOIR_BILL_AMOUNT_NEGATIVE') === 0) {
      messages.push({
        message: i18nType + '.avoirBillAmountNegative',
      });
    }
    if (message.indexOf('GOOGLE_MAP_KEY_INVALID') === 0) {
      messages.push({
        message: i18nType + '.googleMapKeyInvalid',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_DELETE_BILLED_COMMAND_LINE') === 0) {
      messages.push({
        message: i18nType + '.deleteBilledLine',
      });
    }
    if (message.indexOf('POSITIVE_NORMAL_COMMAND_LINE_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.positiveNormalCommandLineForbidden',
      });
    }
    if (message.indexOf('INVOICE_FINANCIAL_COMMITMENT_DATE_INVALID') === 0) {
      const elements = message.split('|')[0].split('@');
      const payeur = elements[1];
      messages.push({
        message: i18nType + '.invoiceFinancialCommitmentDateInvalid',
        parametres: {
          nomCommercial: payeur,
        },
      });
    }
    if (message.indexOf('INVOICE_FINANCIAL_COMMITMENT_COUNT_INVALID') === 0) {
      const elements = message.split('|')[0].split('@');
      const payeur = elements[1];
      messages.push({
        message: i18nType + '.invoiceFinancialCommitmentCountInvalid',
        parametres: {
          nomCommercial: payeur,
        },
      });
    }
    if (message.indexOf('INVOICE_LOCKED_PAYER') === 0) {
      const elements = message.split('|')[0].split('@');
      const payeur = elements[1];
      messages.push({
        message: i18nType + '.invoiceLockedPayer',
        parametres: {
          nomCommercial: payeur,
        },
      });
    }
    if (message.indexOf('COMMANDE_LOCKED_CLIENT') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.lockedClient',
        parametres: { nomCommercial: params[1] },
      });
    }
    if (message.indexOf('PRODUCT_SHOULD_BE_PURCHASE') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.productPurchase',
        parametres: { libelle: params[1] },
      });
    }
    if (message.indexOf('FACE_NOT_AVAILABLE') === 0) {
      const params = message.split('|')[0].split('@');
      if (reseaux && reseaux.length) {
        reseaux.forEach((reseau) => {
          reseau.listeFaces.forEach((f) => {
            if (f.facNum === params[1] || f.idProduit === params[1] && reseau.num === params[3]) {
              messages.push({
                message: i18nType + '.faceNotAvailableInSelection',
                parametres: { face: f.facCode, reseau: reseau.libelle, semaine: params[2] },
              });
            }
          });
        });
      }
    }
    if (message.indexOf('AMOUNT_SELECTED_IS_GREATER_THAN_AMOUNT_WISH') === 0) {
      messages.push({
        message: i18nType + '.faceSelectGreaterThanFaceWish',
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUIT_HAS_PARTIAL_SELECTION') === 0) {
      const params = message.split('|')[0].split('@');
      const semaine = moment(params[3], 'GGGGWW').format('WW');
      const annee = moment(params[3], 'GGGGWW').format('GGGG');
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitHasPartialSelection',
        parametres: {
          face: params[1],
          reseau: params[2],
          semaine,
          annee,
        },
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUIT_HAS_TFS') === 0) {
      const params = message.split('|')[0].split('@');
      const semaine = moment(params[3], 'GGGGWW').format('WW');
      const annee = moment(params[3], 'GGGGWW').format('GGGG');
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitHasTfs',
        parametres: {
          face: params[1],
          reseau: params[2],
          semaine,
          annee,
        },
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUIT_ONE_NOT_EXIST') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitOneNotExist',
        parametres: { ligne: params[1] },
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUIT_SELECTED_ONCE') === 0) {
      const params = message.split('|')[0].split('@');
      const semaine = moment(params[3], 'GGGGWW').format('WW');
      const annee = moment(params[3], 'GGGGWW').format('GGGG');
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitSelectedOnce',
        parametres: {
          face: params[1],
          reseau: params[2],
          semaine,
          annee,
        },
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEP_OPTION_PRODUIT_IS_INACTIVE') === 0) {
      const params = message.split('|')[0].split('@');
      const semaine = moment(params[3], 'GGGGWW').format('WW');
      const annee = moment(params[3], 'GGGGWW').format('GGGG');
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitIsInactive',
        parametres: {
          face: params[1],
          reseau: params[2],
          semaine,
          annee,
        },
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUITS_IN_DEVIS') === 0) {
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitsInDevis',
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUITS_IN_DEVIS_ACHAT') === 0) {
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitsInDevisVente',
      });
    }
    if (message.indexOf('DEVIS_LIGNE_CMD_SEL_OPTION_PRODUITS_IN_VENTE_TEMPOS') === 0) {
      messages.push({
        message: i18nType + '.ligneCmdSelOptionProduitsInVenteTempos',
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/validation.js